module.exports = __webpack_public_path__ + "img/foto5.7fe9f6de.jpg";